export default __webpack_public_path__ + "static/media/trend-neutral-plus.38cfaa29.svg";